// @core/api/endpoints/subscription/set_subscription_plan_change.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetSubscriptionPlanChangeRequest,
  SetSubscriptionPlanChangeResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Change subscription plan
 * Upgrades or downgrades the subscription to a different plan. Handles proration, credit calculation, and feature transitions.
 */
export async function SetSubscriptionPlanChange(
  subscription_id: string,
  data: SetSubscriptionPlanChangeRequest,
  options?: RequestOptions
): Promise<SetSubscriptionPlanChangeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/plan-change`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<SetSubscriptionPlanChangeResponse>(requestPath, data, requestOptions);
}
